import { render, staticRenderFns } from "./onTrialShipment.vue?vue&type=template&id=57379cc1&scoped=true&"
import script from "./onTrialShipment.vue?vue&type=script&lang=js&"
export * from "./onTrialShipment.vue?vue&type=script&lang=js&"
import style0 from "./onTrialShipment.vue?vue&type=style&index=0&id=57379cc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57379cc1",
  null
  
)

export default component.exports